const DateInput = ({ value="", onChange, className, max }) => {

  return (
    <input
      type="date"
      value={value}
      onChange={onChange}
      max={max}
      className={`
        h-8 rounded-lg w-34
        border border-[#e5e7eb] bg-white
        px-2.5
        text-sm
        outline-none
        transition-colors
        focus:border-[#64A8FF]
        ${className}
      `}
    />
  )
}

export default DateInput